import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["key", "title", "children"],
    _excluded2 = ["key", "title", "children", "isLeaf"],
    _excluded3 = ["showLine", "clsPrefix", "className", "focusable", "checkable", "loadData", "checkStrictly", "tabIndexValue", "lazyLoad", "getScrollContainer", "defaultExpandedKeys", "defaultSelectedKeys", "defaultCheckedKeys", "openAnimation", "draggable", "debounceDuration"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.set.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint no-console:0 */
import React from 'react';
import TreeNode from './TreeNode';
import InfiniteScroll from './infiniteScroll';
import classNames from 'classnames';
import { loopAllChildren, isInclude, getOffset, filterParentPosition, handleCheckState, getCheck, getStrictlyValue, arraysEqual, closest, convertListToTree } from './util';
import PropTypes from 'prop-types';
import { KeyCode } from '../../wui-core/src';
import CONFIG from './config';
import createStore from './createStore';
import omit from 'omit.js';
import { get } from "lodash-es";

function noop() {}

var Tree = /*#__PURE__*/function (_React$Component) {
  _inherits(Tree, _React$Component);

  var _super = _createSuper(Tree);

  function Tree(_props) {
    var _this;

    _classCallCheck(this, Tree);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "hasTreeNode", function () {
      var _this$props = _this.props,
          children = _this$props.children,
          treeData = _this$props.treeData;
      var noTreeNode = children === null || typeof children === 'undefined' || _typeof(children) === 'object' && children.length === 0 || _typeof(treeData) === 'object' && treeData.length === 0;
      return !noTreeNode;
    });

    _defineProperty(_assertThisInitialized(_this), "calculateRowHeight", function () {
      var _this$props2 = _this.props,
          lazyLoad = _this$props2.lazyLoad,
          clsPrefix = _this$props2.clsPrefix; // 启用懒加载，计算树节点真实高度

      if (!lazyLoad) return;

      var treenodes = _this.tree.querySelectorAll(".".concat(clsPrefix, "-treenode-close"))[0];

      if (!treenodes) return;
      _this.hasCalculateRowHeight = true;
      var rowHeight = treenodes.getBoundingClientRect().height;

      _this.store.setState({
        rowHeight: rowHeight || 24
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleTreeListChange", function (treeList, startIndex, endIndex) {
      // 属性配置设置
      var attr = {
        id: 'key',
        parendId: 'parentKey',
        name: 'title',
        rootId: null,
        isLeaf: 'isLeaf'
      };
      var treeData = convertListToTree(treeList, attr, _this.flatTreeKeysMap);
      _this.startIndex = typeof startIndex !== "undefined" ? startIndex : _this.startIndex;
      _this.endIndex = typeof endIndex !== "undefined" ? endIndex : _this.endIndex;

      _this.setState({
        treeData: treeData
      });

      _this.dataChange = true;
    });

    _defineProperty(_assertThisInitialized(_this), "deepTraversal", function (treeData) {
      var parentKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var isShown = arguments.length > 2 ? arguments[2] : undefined;
      var expandedKeys = _this.state.expandedKeys,
          expandedKeysSet = _this.cacheExpandedKeys ? _this.cacheExpandedKeys : new Set(expandedKeys),
          flatTreeData = [],
          flatTreeKeysMap = _this.flatTreeKeysMap,
          dataCopy = treeData;

      if (Array.isArray(dataCopy)) {
        for (var i = 0, l = dataCopy.length; i < l; i++) {
          var _dataCopy$i = dataCopy[i],
              key = _dataCopy$i.key,
              title = _dataCopy$i.title,
              children = _dataCopy$i.children,
              props = _objectWithoutProperties(_dataCopy$i, _excluded),
              dataCopyI = new Object(),
              isLeaf = children ? false : true; //如果父节点是收起状态，则子节点的展开状态无意义。（一级节点或根节点直接判断自身状态即可）


          var isExpanded = parentKey === null || expandedKeysSet.has(parentKey) ? expandedKeysSet.has(key) : false;
          dataCopyI = Object.assign(dataCopyI, {
            key: key,
            title: title,
            isExpanded: isExpanded,
            parentKey: parentKey || null,
            isShown: isShown,
            isLeaf: isLeaf
          }, _objectSpread({}, props)); //该节点的父节点是展开状态 或 该节点是根节点

          if (isShown || parentKey === null) {
            flatTreeData.push(dataCopyI); // 取每项数据放入一个新数组

            flatTreeKeysMap[key] = dataCopyI;
          }

          if (Array.isArray(children) && children.length > 0) {
            // 若存在children则递归调用，把数据拼接到新数组中，并且删除该children
            flatTreeData = flatTreeData.concat(_this.deepTraversal(children, key, isExpanded));
          }
        }
      }

      return flatTreeData;
    });

    _defineProperty(_assertThisInitialized(_this), "renderTreefromData", function (data) {
      var _this$props3 = _this.props,
          renderTitle = _this$props3.renderTitle,
          renderTreeNodes = _this$props3.renderTreeNodes,
          loadData = _this$props3.loadData;

      if (renderTreeNodes) {
        return renderTreeNodes(data);
      }

      var loop = function loop(data) {
        return data.map(function (item) {
          var key = item.key,
              title = item.title,
              children = item.children,
              isLeaf = item.isLeaf,
              others = _objectWithoutProperties(item, _excluded2);

          if (item.children) {
            return /*#__PURE__*/React.createElement(TreeNode, _extends({}, others, {
              key: key,
              title: renderTitle ? renderTitle(item) : title,
              isLeaf: isLeaf
            }), loop(item.children));
          }

          return /*#__PURE__*/React.createElement(TreeNode, _extends({}, others, {
            key: key,
            title: renderTitle ? renderTitle(item) : title,
            isLeaf: isLeaf
          }));
        });
      };

      return loop(data);
    });

    _defineProperty(_assertThisInitialized(_this), "getSumHeight", function (start, end) {
      var sumHeight = 0;

      if (start > end) {
        return sumHeight;
      }

      var span = Math.abs(end - start);

      if (span) {
        sumHeight = span * _this.store.getState().rowHeight;
      }

      return sumHeight;
    });

    ['onKeyDown', 'onCheck', "onUlFocus", "_focusDom", "onUlMouseEnter", "onUlMouseLeave"].forEach(function (m) {
      _this[m] = _this[m].bind(_assertThisInitialized(_this));
    });
    _this.contextmenuKeys = [];
    _this.latestTreeNode = {};
    _this.checkedKeysChange = true;
    _this.selectKeyDomPos = '0-0';
    _this.autoExpandKeys = null;
    var _this$props4 = _this.props,
        defaultExpandedKeys = _this$props4.defaultExpandedKeys,
        loadData = _this$props4.loadData; // 如果是异步加载数据，而且传了默认展开的节点key，这些key不放在第一次渲染的expandedKeys当中，而是在treeNode渲染的时候，调用打开的方法展开

    if (defaultExpandedKeys && Array.isArray(defaultExpandedKeys) && defaultExpandedKeys.length && loadData) {
      _this.autoExpandKeys = defaultExpandedKeys;
    }

    _this.state = {
      expandedKeys: _this.getDefaultExpandedKeys(_props),
      checkedKeys: _this.getDefaultCheckedKeys(_props),
      selectedKeys: _this.getDefaultSelectedKeys(_props),
      dragNodesKeys: '',
      dragOverNodeKey: '',
      dropNodeKey: '',
      focusKey: '',
      //上下箭头选择树节点时，用于标识focus状态
      treeData: [],
      //Tree结构数组(全量)
      flatTreeData: [],
      //一维数组(全量)
      prevProps: null
    }; //默认显示20条，rowsInView根据定高算的。在非固定高下，这个只是一个大概的值。

    _this.rowsInView = CONFIG.defaultRowsInView; //一次加载多少数据

    _this.loadCount = CONFIG.loadBuffer ? _this.rowsInView + CONFIG.loadBuffer * 2 : 16;
    _this.flatTreeKeysMap = {}; //存储所有 key-value 的映射，方便获取各节点信息

    _this.startIndex = 0;
    _this.endIndex = _this.startIndex + _this.loadCount;
    _this.cacheTreeNodes = []; //缓存 treenode 节点数组

    _this.store = createStore({
      rowHeight: 24
    }); //rowHeight 树节点的高度，此变量在滚动加载场景很关键

    _this.latestState = null;
    _this.cachedLatestState = null;
    return _this;
  }

  _createClass(Tree, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // 此处为了区分数据是不是异步渲染的，prevProps 作为标识
      if (this.hasTreeNode()) {
        this.setState({
          prevProps: this.props
        });
      } // ncc制造，树参照包含下级需求，checkStrictly 动态改变后，拿到组件内部属性 this.checkedKeys


      if (this.props._getTreeObj) {
        this.props._getTreeObj(this);
      }

      this.calculateRowHeight();
    } // 判断初始化挂载时，有没有渲染树节点

  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      var _this$props5 = this.props,
          treeData = _this$props5.treeData,
          lazyLoad = _this$props5.lazyLoad;
      var sliceTreeList = []; //启用懒加载，把 Tree 结构拍平，为后续动态截取数据做准备

      if (lazyLoad) {
        var flatTreeData = this.deepTraversal(treeData);
        flatTreeData.forEach(function (element) {
          if (sliceTreeList.length >= _this2.loadCount) return;
          sliceTreeList.push(element);
        });
        this.handleTreeListChange(sliceTreeList);
        this.setState({
          flatTreeData: flatTreeData
        });
      } else {
        this.setState({
          treeData: treeData
        });
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var flatTreeDataDone = false; //已经更新过flatTree

      var startIndex = this.startIndex,
          endIndex = this.endIndex,
          props = this.props,
          state = this.state;
      var prevProps = state.prevProps;
      var expandedKeys = this.getDefaultExpandedKeys(nextProps, true);
      var checkedKeys = this.getDefaultCheckedKeys(nextProps, true);
      var selectedKeys = this.getDefaultSelectedKeys(nextProps, true);
      var st = {
        prevProps: nextProps
      }; // 用于记录这次data内容有没有变化

      this.dataChange = false;

      function needSync(name) {
        return !prevProps && name in nextProps || prevProps && prevProps[name] !== nextProps[name];
      } // ================ expandedKeys =================


      if (needSync('expandedKeys') || prevProps && needSync('autoExpandParent') || prevProps && prevProps['expandedKeys'] !== expandedKeys) {
        st.expandedKeys = expandedKeys;
      } else if (!prevProps && props.defaultExpandAll || !prevProps && props.defaultExpandedKeys) {
        st.expandedKeys = this.getDefaultExpandedKeys(nextProps);
      }

      if (st.expandedKeys) {
        //缓存 expandedKeys
        this.cacheExpandedKeys = new Set(expandedKeys);

        if (nextProps.lazyLoad) {
          var flatTreeData = this.deepTraversal(nextProps.treeData);
          this.cacheExpandedKeys = null;
          st.flatTreeData = flatTreeData;
          var newTreeList = flatTreeData.slice(startIndex, endIndex);
          this.handleTreeListChange(newTreeList, startIndex, endIndex);
          flatTreeDataDone = true;
        }
      } // ================ checkedKeys =================


      if (checkedKeys) {
        if (nextProps.checkedKeys === this.props.checkedKeys) {
          this.checkedKeysChange = false;
        } else {
          this.checkedKeysChange = true;
        }

        st.checkedKeys = checkedKeys;
      } // ================ selectedKeys =================


      if (selectedKeys) {
        st.selectedKeys = selectedKeys;
      } // ================ treeData =================


      if (nextProps.hasOwnProperty('treeData') && nextProps.treeData !== this.props.treeData) {
        this.dataChange = true; //treeData更新时，需要重新处理一次数据

        if (nextProps.lazyLoad) {
          if (!flatTreeDataDone) {
            var _flatTreeData = this.deepTraversal(nextProps.treeData);

            st.flatTreeData = _flatTreeData;

            var _newTreeList = _flatTreeData.slice(startIndex, endIndex);

            this.handleTreeListChange(_newTreeList, startIndex, endIndex);
          }
        } else {
          st.treeData = nextProps.treeData;
        }
      } // ================ children =================


      if (nextProps.children !== this.props.children) {
        this.dataChange = true;
      }

      this.setState(st);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!this.hasCalculateRowHeight) {
        this.calculateRowHeight();
      }
    }
  }, {
    key: "onDragStart",
    value: function onDragStart(e, treeNode) {
      this.dragNode = treeNode;
      this.dragNodesKeys = this.getDragNodes(treeNode);
      var st = {
        dragNodesKeys: this.dragNodesKeys
      };
      var expandedKeys = this.getExpandedKeys(treeNode, false);

      if (expandedKeys) {
        // Controlled expand, save and then reset
        this.getRawExpandedKeys();
        st.expandedKeys = expandedKeys;
      }

      this.setState(st);
      this.props.onDragStart({
        event: e,
        node: treeNode
      });
      this._dropTrigger = false;
    }
  }, {
    key: "onDragEnterGap",
    value: function onDragEnterGap(e, treeNode) {
      var offsetTop = (0, getOffset)(treeNode.selectHandle).top;
      var offsetHeight = treeNode.selectHandle.offsetHeight;
      var pageY = e.pageY;
      var gapHeight = 2;

      if (pageY > offsetTop + offsetHeight - gapHeight) {
        this.dropPosition = 1;
        return 1;
      }

      if (pageY < offsetTop + gapHeight) {
        this.dropPosition = -1;
        return -1;
      }

      this.dropPosition = 0;
      return 0;
    }
  }, {
    key: "onDragEnter",
    value: function onDragEnter(e, treeNode) {
      var enterGap = this.onDragEnterGap(e, treeNode);

      if (this.dragNode.props.eventKey === treeNode.props.eventKey && enterGap === 0) {
        this.setState({
          dragOverNodeKey: ''
        });
        return;
      }

      var st = {
        dragOverNodeKey: treeNode.props.eventKey
      };
      var expandedKeys = this.getExpandedKeys(treeNode, true);

      if (expandedKeys) {
        this.getRawExpandedKeys();
        st.expandedKeys = expandedKeys;
      }

      this.setState(st);
      this.props.onDragEnter({
        event: e,
        node: treeNode,
        expandedKeys: expandedKeys && _toConsumableArray(expandedKeys) || _toConsumableArray(this.state.expandedKeys)
      });
    }
  }, {
    key: "onDragOver",
    value: function onDragOver(e, treeNode) {
      this.props.onDragOver({
        event: e,
        node: treeNode
      });
    }
  }, {
    key: "onDragLeave",
    value: function onDragLeave(e, treeNode) {
      this.props.onDragLeave({
        event: e,
        node: treeNode
      });
    }
  }, {
    key: "onDrop",
    value: function onDrop(e, treeNode) {
      var key = treeNode.props.eventKey;
      this.setState({
        dragOverNodeKey: '',
        dropNodeKey: key
      });

      if (this.dragNodesKeys.indexOf(key) > -1) {
        if (console.warn) {
          console.warn('can not drop to dragNode(include it\'s children node)');
        }

        return false;
      }

      var posArr = treeNode.props.pos.split('-');
      var res = {
        event: e,
        node: treeNode,
        dragNode: this.dragNode,
        dragNodesKeys: _toConsumableArray(this.dragNodesKeys),
        dropPosition: this.dropPosition + Number(posArr[posArr.length - 1])
      };

      if (this.dropPosition !== 0) {
        res.dropToGap = true;
      }

      if ('expandedKeys' in this.props) {
        res.rawExpandedKeys = _toConsumableArray(this._rawExpandedKeys) || _toConsumableArray(this.state.expandedKeys);
      }

      this.props.onDrop(res);
      this._dropTrigger = true;
    }
  }, {
    key: "onDragEnd",
    value: function onDragEnd(e, treeNode) {
      this.setState({
        dragOverNodeKey: ''
      });
      this.props.onDragEnd({
        event: e,
        node: treeNode
      });
    }
    /**
     *
     *
     * @param {*} treeNode 当前操作的节点
     * @param {*} keyType 键盘事件通用的key类型 left 为收起，right为展开
     * @returns
     * @memberof Tree
     */

  }, {
    key: "onExpand",
    value: function onExpand(treeNode, keyType) {
      var _this3 = this;

      var _this$props6 = this.props,
          treeData = _this$props6.treeData,
          lazyLoad = _this$props6.lazyLoad;
      var expanded = !treeNode.props.expanded;
      this.latestState = expanded;
      this.cachedLatestState = treeNode.props.expanded;
      this.latestTreeNode = treeNode.props;
      var controlled = ('expandedKeys' in this.props);

      var expandedKeys = _toConsumableArray(this.state.expandedKeys);

      var index = expandedKeys.indexOf(treeNode.props.eventKey);

      if (keyType == 'left') {
        expanded = false;
      } else if (keyType == 'right') {
        expanded = true;
      }

      if (expanded && index === -1) {
        expandedKeys.push(treeNode.props.eventKey);
      } else if (!expanded && index > -1) {
        expandedKeys.splice(index, 1);
      }

      if (!controlled) {
        this.setState({
          expandedKeys: expandedKeys
        });
      }

      this.props.onExpand(expandedKeys, {
        node: treeNode,
        expanded: expanded
      }); //收起和展开时，缓存 expandedKeys

      this.cacheExpandedKeys = new Set(expandedKeys); // after data loaded, need set new expandedKeys

      if (expanded && this.props.loadData) {
        return this.props.loadData(treeNode).then(function () {
          if (!controlled) {
            _this3.setState({
              expandedKeys: expandedKeys
            });
          }
        });
      } //启用懒加载，把 Tree 结构拍平，为后续动态截取数据做准备


      if (lazyLoad) {
        var flatTreeData = this.deepTraversal(treeData);
        this.cacheExpandedKeys = null;
        this.setState({
          flatTreeData: flatTreeData
        });
      }
    }
  }, {
    key: "onCheck",
    value: function onCheck(treeNode, event) {
      var _this4 = this;

      var checked = !treeNode.props.checked;
      var lazyLoad = this.props.lazyLoad;

      if (treeNode.props.halfChecked) {
        checked = true;
      }

      var key = treeNode.props.eventKey;

      var checkedKeys = _toConsumableArray(this.state.checkedKeys);

      var index = checkedKeys.indexOf(key); // index很有可能是-1

      var newSt = {
        event: 'check',
        node: treeNode,
        checked: checked,
        eventObject: event
      };
      var oldCheckedKeys = this.state.checkedKeys;

      if (this.props.checkStrictly) {
        var rsCheckedKeys = [];

        if (checked && index === -1) {
          checkedKeys.push(key); // rsCheckedKeys.push(key);//onCheck第一个参数的key不对
        }

        if (!checked && index > -1) {
          checkedKeys.splice(index, 1);
        }

        this.treeNodesStates[treeNode.props.pos].checked = checked;
        newSt.checkedNodes = [];
        var childs = this.props.children;
        var _this$props7 = this.props,
            renderTreeNodes = _this$props7.renderTreeNodes,
            treeData = _this$props7.treeData;

        if (renderTreeNodes && treeData) {
          childs = renderTreeNodes(treeData);
        }

        loopAllChildren(childs, function (item, ind, pos, keyOrPos) {
          if (checkedKeys.indexOf(keyOrPos) !== -1) {
            newSt.checkedNodes.push(item);
            rsCheckedKeys.push(keyOrPos);
          }
        });

        if (!('checkedKeys' in this.props)) {
          this.setState({
            checkedKeys: rsCheckedKeys
          });
        }

        var halfChecked = this.props.checkedKeys ? this.props.checkedKeys.halfChecked : [];
        this.props.onCheck(getStrictlyValue(rsCheckedKeys, halfChecked), newSt);
      } else {
        if (checked && index === -1) {
          this.treeNodesStates[treeNode.props.pos].checked = true;
          var checkedPositions = [];
          Object.keys(this.treeNodesStates).forEach(function (i) {
            if (_this4.treeNodesStates[i].checked) {
              checkedPositions.push(i);
            }
          });
          handleCheckState(this.treeNodesStates, filterParentPosition(checkedPositions), true);
        }

        if (!checked) {
          this.treeNodesStates[treeNode.props.pos].checked = false;
          this.treeNodesStates[treeNode.props.pos].halfChecked = false;
          handleCheckState(this.treeNodesStates, [treeNode.props.pos], false);
        }

        var checkKeys = getCheck(this.treeNodesStates);
        newSt.checkedNodes = checkKeys.checkedNodes;
        newSt.checkedNodesPositions = checkKeys.checkedNodesPositions;
        newSt.halfCheckedKeys = checkKeys.halfCheckedKeys;
        this.checkKeys = checkKeys;
        this._checkedKeys = checkedKeys = checkKeys.checkedKeys;

        if (!('checkedKeys' in this.props)) {
          if (!checked) {
            oldCheckedKeys = oldCheckedKeys.filter(function (oldCheckedKey) {
              // 旧的已选的数据如果被取消勾选，从旧的已选数据种去掉
              return oldCheckedKey !== key;
            });
          }

          this.setState({
            checkedKeys: lazyLoad ? [].concat(_toConsumableArray(oldCheckedKeys), _toConsumableArray(checkedKeys)) : checkedKeys
          });
        }

        this.props.onCheck(checkedKeys, newSt);
      }
    }
  }, {
    key: "onSelect",
    value: function onSelect(treeNode) {
      var props = this.props;

      var selectedKeys = _toConsumableArray(this.state.selectedKeys);

      var eventKey = treeNode.props.eventKey || treeNode.key;
      var index = selectedKeys.indexOf(eventKey);
      var selected; //cancelUnSelect为true时第二次点击时不取消选中

      if (props.cancelUnSelect) {
        if (index == -1) {
          selected = true;

          if (!props.multiple) {
            selectedKeys.length = 0;
          }

          selectedKeys.push(eventKey);
        }
      } else {
        if (index !== -1) {
          selected = false;
          selectedKeys.splice(index, 1);
        } else {
          selected = true;

          if (!props.multiple) {
            selectedKeys.length = 0;
          }

          selectedKeys.push(eventKey);
        }
      }

      var selectedNodes = [];

      if (selectedKeys.length) {
        var treeNodes = this.props.children || treeNode.props.root.cacheTreeNodes;
        loopAllChildren(treeNodes, function (item) {
          if (selectedKeys.indexOf(item.key) !== -1) {
            selectedNodes.push(item);
          }
        });
      }

      var newSt = {
        event: 'select',
        node: treeNode,
        selected: selected,
        selectedNodes: selectedNodes
      };

      if (!('selectedKeys' in this.props)) {
        this.setState({
          selectedKeys: selectedKeys
        });
      }

      this.setState({
        focusKey: ''
      });
      props.onSelect(selectedKeys, newSt);
    }
  }, {
    key: "onDoubleClick",
    value: function onDoubleClick(treeNode) {
      var props = this.props;
      var eventKey = treeNode.props.eventKey;
      var newSt = {
        event: 'dblclick',
        node: treeNode
      };

      if (props.expandWhenDoubleClick) {
        this.onExpand(treeNode);
      }

      props.onDoubleClick(eventKey, newSt);
    }
  }, {
    key: "onMouseEnter",
    value: function onMouseEnter(e, treeNode) {
      this.props.onMouseEnter({
        event: e,
        node: treeNode
      });
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave(e, treeNode) {
      this.props.onMouseLeave({
        event: e,
        node: treeNode
      });
    }
  }, {
    key: "onContextMenu",
    value: function onContextMenu(e, treeNode) {
      var selectedKeys = _toConsumableArray(this.state.selectedKeys);

      var eventKey = treeNode.props.eventKey;

      if (this.contextmenuKeys.indexOf(eventKey) === -1) {
        this.contextmenuKeys.push(eventKey);
      }

      this.contextmenuKeys.forEach(function (key) {
        var index = selectedKeys.indexOf(key);

        if (index !== -1) {
          selectedKeys.splice(index, 1);
        }
      });

      if (selectedKeys.indexOf(eventKey) === -1) {
        selectedKeys.push(eventKey);
      }

      this.setState({
        selectedKeys: selectedKeys
      });
      this.props.onRightClick({
        event: e,
        node: treeNode
      });
    }
  }, {
    key: "getTreeNode",
    value: function getTreeNode() {
      var props = this.props;
    }
  }, {
    key: "goDown",
    value: function goDown(currentPos, currentIndex, e, treeNode) {
      var props = this.props;
      var state = this.state;
      var treeChildren = props.children ? props.children : this.cacheTreeNodes; //最终渲染在 Tree 标签中的子节点

      var nextIndex = parseInt(currentIndex) + 1;
      var nextPos, backNextPos;
      var nextTreeNode, backNextTreeNode;
      var backNextPosArr = [],
          backNextTreeNodeArr = [],
          tempBackNextPosArr = []; //是否为展开的节点，如果展开获取第一个子节点的信息，如果没有取相邻节点，若也没有相邻节点则获取父节点的下一个节点

      if (state.expandedKeys.indexOf(treeNode.props.eventKey) > -1) {
        nextPos = currentPos + '-0';
      } else {
        nextPos = currentPos.substr(0, currentPos.lastIndexOf('-') + 1) + nextIndex;
      } //若向下的节点没有了，找到父级相邻节点


      var tempPosArr = currentPos.split('-');
      var tempPosArrLength = tempPosArr.length; //将可能是下一个节点的的位置都备份一遍

      while (tempPosArrLength > 1) {
        backNextPos = tempPosArrLength > 1 && tempPosArr.slice(0, tempPosArrLength - 1).join('-') + '-' + (parseInt(tempPosArr[tempPosArrLength - 1]) + 1);
        tempBackNextPosArr.push(backNextPos);
        tempPosArr = tempPosArr.slice(0, tempPosArrLength - 1);
        tempPosArrLength = tempPosArr.length;
      } //选中下一个相邻的节点


      loopAllChildren(treeChildren, function (itemNode, index, pos, newKey) {
        if (pos == nextPos) {
          nextTreeNode = itemNode;
        }

        tempBackNextPosArr.forEach(function (item) {
          if (item && item == pos) {
            // backNextTreeNode = item;
            backNextTreeNodeArr.push(itemNode);
            backNextPosArr.push(pos);
          }
        });
      }); //如果没有下一个节点，则获取父节点的下一个节点

      if (!nextTreeNode) {
        for (var i = 0; i < backNextTreeNodeArr.length; i++) {
          if (backNextTreeNodeArr[i]) {
            nextTreeNode = backNextTreeNodeArr[i];
            nextPos = backNextPosArr[i];
            break;
          }
        }
      } //查询的下一个节点不为空的话，则选中


      if (nextTreeNode) {
        var queryInfo = "a[pos=\"".concat(nextPos, "\"]");
        var parentEle = closest(e.target, ".".concat(props.clsPrefix));
        var focusEle = parentEle ? parentEle.querySelector(queryInfo) : null;
        focusEle && focusEle.focus();
        var eventKey = nextTreeNode.props.eventKey || nextTreeNode.key;
        this.setState({
          focusKey: eventKey
        });

        if (props.autoSelectWhenFocus) {
          this.onSelect(nextTreeNode);
        }
      } else {
        this._setDataTransfer(e);

        console.debug('%c[bee-tree] [goDown()] nextTreeNode is null, e ==> ', 'color:blue', e);
      }
    }
  }, {
    key: "goUp",
    value: function goUp(currentPos, currentIndex, e, treeNode) {
      var props = this.props;
      var state = this.state;

      if (currentIndex == 0 && currentPos.length === 3) {
        this._setDataTransfer(e);

        console.debug('%c[bee-tree] [goUp()] return with noting to do because currentIndex == 0 && currentPos.length === 3, e ==> ', 'color:blue', e);
        return;
      } // 向上键Up


      var preIndex = parseInt(currentIndex) - 1;
      var prePos;

      if (preIndex >= 0) {
        prePos = currentPos.substr(0, currentPos.lastIndexOf('-') + 1) + preIndex;
      } else {
        prePos = currentPos.substr(0, currentPos.lastIndexOf('-'));
      }

      var prevTreeNode, preElement;
      var treeNodes = props.children || this.cacheTreeNodes; //选中上一个相邻的节点

      loopAllChildren(treeNodes, function (item, index, pos, newKey) {
        if (pos == prePos) {
          prevTreeNode = item;
        }
      }); //查询的上一个节点不为空的话，则选中

      if (prevTreeNode) {
        if (preIndex >= 0) {
          //如果上面的节点展开则默认选择最后一个子节点
          if (state.expandedKeys.indexOf(prevTreeNode.key) > -1) {
            var preElementArr = e.target.parentElement.previousElementSibling.querySelectorAll('a');
            preElement = preElementArr[preElementArr.length - 1];
            prePos = preElement.getAttribute('pos');
            loopAllChildren(props.children, function (item, index, pos, newKey) {
              if (pos == prePos) {
                prevTreeNode = item;
              }
            });
          } else {
            //上一个节点没有展开
            preElement = e.target.parentElement.previousElementSibling.querySelector('a');
          }
        } else {
          // 不存在上一个节点时，选中它的父节点
          preElement = e.target.parentElement.parentElement.parentElement.querySelector('a');
        }
      } else {
        this._setDataTransfer(e);

        console.debug('%c[bee-tree] [goUp()] prevTreeNode is null, e ==> ', 'color:blue', e);
      }

      if (!preElement) {
        this._setDataTransfer(e);

        console.debug('%c[bee-tree] [goUp()] preElement is null, e ==> ', 'color:blue', e);
      }

      preElement && preElement.focus();
      var eventKey = prevTreeNode.props.eventKey || prevTreeNode.key;
      this.setState({
        focusKey: eventKey
      });

      if (props.autoSelectWhenFocus) {
        this.onSelect(prevTreeNode);
      }
    } // all keyboard events callbacks run from here at first

  }, {
    key: "onKeyDown",
    value: function onKeyDown(e, treeNode) {
      // e.stopPropagation();
      var props = this.props;
      var currentPos = treeNode.props.pos;
      var selectable = treeNode.props.selectable;
      var currentIndex = currentPos.substr(currentPos.lastIndexOf('-') + 1); //向下键down

      if (e.keyCode == KeyCode.DOWN) {
        this.goDown(currentPos, currentIndex, e, treeNode);
      } else if (e.keyCode == KeyCode.UP) {
        this.goUp(currentPos, currentIndex, e, treeNode);
      } else if (e.keyCode == KeyCode.LEFT && !treeNode.props.isLeaf) {
        // 收起树节点
        this.onExpand(treeNode, 'left');
      } else if (e.keyCode == KeyCode.RIGHT && !treeNode.props.isLeaf) {
        // 展开树节点
        this.onExpand(treeNode, 'right');
      } else if (e.keyCode == KeyCode.SPACE) {
        this.onSelect(treeNode); // 如果是多选tree则进行选中或者反选该节点

        props.checkable && this.onCheck(treeNode);
      } else if (e.keyCode == KeyCode.ENTER) {
        if (props.onDoubleClick) {
          this.onDoubleClick(treeNode);
        } else {
          selectable && this.onSelect(treeNode);
          props.checkable && this.onCheck(treeNode);
        }
      }

      this.props.keyFun && this.props.keyFun(e, treeNode); // e.preventDefault();
    }
  }, {
    key: "_setDataTransfer",
    value: function _setDataTransfer(e) {
      e.target._dataTransfer = {
        ooo: 'bee-tree',
        _cancelBubble: false // 向上层发出不取消冒泡标识，表示bee-Tree不处理该事件，上层可以处理

      };
    }
  }, {
    key: "_focusDom",
    value: function _focusDom(selectKeyDomPos, targetDom) {
      var queryInfo = "a[pos=\"".concat(selectKeyDomPos, "\"]");
      var parentEle = closest(targetDom, ".".concat(this.props.clsPrefix));
      var focusEle = parentEle ? parentEle.querySelector(queryInfo) : null;

      if (document.activeElement !== focusEle) {
        focusEle && focusEle.focus();
      }
    }
    /**
     * 此方法为了解决树快捷键，当有的元素隐藏，按tab键也要显示的问题
     * @param {*} e
     */

  }, {
    key: "onUlFocus",
    value: function onUlFocus(e) {
      var _this5 = this;

      var targetDom = e.target; // 如果当前tree节点不包括上一个焦点节点会触发此方法

      if (this.tree == targetDom && !this.tree.contains(e.relatedTarget)) {
        var _this$props8 = this.props,
            onFocus = _this$props8.onFocus,
            children = _this$props8.children;
        var _this$state$selectedK = this.state.selectedKeys,
            selectedKeys = _this$state$selectedK === void 0 ? [] : _this$state$selectedK;
        var tabIndexKey = selectedKeys[0];
        var isExist = false;
        var treeNode = children && children.length && children[0];
        var eventKey = treeNode && (treeNode.props.eventKey || treeNode.key);

        if (this.selectKeyDomExist && tabIndexKey || !tabIndexKey) {
          isExist = true;
          var queryInfo = "a[pos=\"".concat(this.selectKeyDomPos, "\"]");
          var parentEle = closest(e.target, ".".concat(this.props.clsPrefix));
          var focusEle = parentEle ? parentEle.querySelector(queryInfo) : null;
          focusEle && focusEle.focus(); // TAB键选中树后，默认聚焦在第一个（已选中）节点，并显示 focus 状态。

          this.setState({
            focusKey: tabIndexKey || eventKey
          });
        }

        var onFocusRes = onFocus && onFocus(isExist);

        if (onFocusRes instanceof Promise) {
          onFocusRes.then(function () {
            _this5._focusDom(_this5.selectKeyDomPos, targetDom);
          });
        } else {
          this._focusDom(this.selectKeyDomPos, targetDom);
        }
      }
    }
  }, {
    key: "onUlMouseEnter",
    value: function onUlMouseEnter(e) {
      console.log('onUlMouseEnter----isIn-----');
    }
  }, {
    key: "onUlMouseLeave",
    value: function onUlMouseLeave(e) {
      console.log('onUlMouseLeave----isIn-----');
    }
  }, {
    key: "getFilterExpandedKeys",
    value: function getFilterExpandedKeys(props, expandKeyProp, expandAll) {
      var _this6 = this;

      var keys = props[expandKeyProp];

      if (expandKeyProp === 'defaultExpandedKeys' // 如果默认展开值数组有值的话，这些值不作为展开值
      && this.autoExpandKeys && this.autoExpandKeys.length) {
        keys = [];
      }

      if (!expandAll && !props.autoExpandParent) {
        return keys || [];
      }

      var expandedPositionArr = [];

      if (props.autoExpandParent) {
        loopAllChildren(props.children, function (item, index, pos, newKey) {
          if (keys.indexOf(newKey) > -1) {
            expandedPositionArr.push(pos);
          }
        });
      }

      var filterExpandedKeys = [];
      var removeRoot = this.latestState === false && props.canCloseFreely;
      var cachedLatestState = this.latestState; // 这个值用来判断此次刷新是否是因为点击了展开/收回

      this.latestState = null;
      loopAllChildren(props.children, function (item, index, pos, newKey) {
        if (expandAll) {
          filterExpandedKeys.push(newKey);
        } else if (props.autoExpandParent) {
          expandedPositionArr.forEach(function (p) {
            if ((p.split('-').length > pos.split('-').length && isInclude(pos.split('-'), p.split('-')) || pos === p) && filterExpandedKeys.indexOf(newKey) === -1) {
              if (!props.canCloseFreely || (cachedLatestState === null ? true : _this6.cacheExpandedKeys ? _this6.cacheExpandedKeys.has(newKey) : true)) {
                filterExpandedKeys.push(newKey);
              }
            }
          });
        }
      });

      if (removeRoot && this.latestTreeNode.eventKey && filterExpandedKeys.includes(this.latestTreeNode.eventKey)) {
        var index = filterExpandedKeys.indexOf(this.latestTreeNode.eventKey);
        filterExpandedKeys.splice(index, 1);
      }

      return filterExpandedKeys.length ? filterExpandedKeys : keys;
    }
  }, {
    key: "getDefaultExpandedKeys",
    value: function getDefaultExpandedKeys(props, willReceiveProps) {
      var expandedKeys = willReceiveProps ? undefined : this.getFilterExpandedKeys(props, 'defaultExpandedKeys', props.defaultExpandedKeys.length ? false : props.defaultExpandAll);

      if ('expandedKeys' in props) {
        expandedKeys = (props.autoExpandParent ? this.getFilterExpandedKeys(props, 'expandedKeys', false) : props.expandedKeys) || [];
      }

      return expandedKeys;
    }
  }, {
    key: "getDefaultCheckedKeys",
    value: function getDefaultCheckedKeys(props, willReceiveProps) {
      var checkedKeys = willReceiveProps ? undefined : props.defaultCheckedKeys;

      if ('checkedKeys' in props) {
        checkedKeys = props.checkedKeys || [];

        if (props.checkStrictly) {
          if (get(props, ['checkedKeys', 'checked'])) {
            checkedKeys = props.checkedKeys.checked;
          } else if (!Array.isArray(props.checkedKeys)) {
            checkedKeys = [];
          }
        }
      }

      return checkedKeys;
    }
  }, {
    key: "getDefaultSelectedKeys",
    value: function getDefaultSelectedKeys(props, willReceiveProps) {
      var getKeys = function getKeys(keys) {
        if (props.multiple) {
          return _toConsumableArray(keys);
        }

        if (keys.length) {
          return [keys[0]];
        }

        return keys;
      };

      var selectedKeys = willReceiveProps ? undefined : getKeys(props.defaultSelectedKeys);

      if ('selectedKeys' in props) {
        selectedKeys = getKeys(props.selectedKeys);
      }

      return selectedKeys;
    }
  }, {
    key: "getRawExpandedKeys",
    value: function getRawExpandedKeys() {
      if (!this._rawExpandedKeys && 'expandedKeys' in this.props) {
        this._rawExpandedKeys = _toConsumableArray(this.state.expandedKeys);
      }
    }
  }, {
    key: "getOpenTransitionName",
    value: function getOpenTransitionName() {
      var props = this.props;
      var transitionName = props.openTransitionName;
      var animationName = props.openAnimation;

      if (!transitionName && typeof animationName === 'string') {
        transitionName = "".concat(props.clsPrefix, "-open-").concat(animationName);
      }

      return transitionName;
    }
  }, {
    key: "getDragNodes",
    value: function getDragNodes(treeNode) {
      var dragNodesKeys = [];
      var tPArr = treeNode.props.pos.split('-');
      loopAllChildren(this.props.children, function (item, index, pos, newKey) {
        var pArr = pos.split('-');

        if (treeNode.props.pos === pos || tPArr.length < pArr.length && isInclude(tPArr, pArr)) {
          dragNodesKeys.push(newKey);
        }
      });
      return dragNodesKeys;
    }
  }, {
    key: "getExpandedKeys",
    value: function getExpandedKeys(treeNode, expand) {
      var key = treeNode.props.eventKey;
      var expandedKeys = this.state.expandedKeys;
      var expandedIndex = expandedKeys.indexOf(key);
      var exKeys;

      if (expandedIndex > -1 && !expand) {
        exKeys = _toConsumableArray(expandedKeys);
        exKeys.splice(expandedIndex, 1);
        return exKeys;
      }

      if (expand && expandedKeys.indexOf(key) === -1) {
        return expandedKeys.concat([key]);
      }
    }
  }, {
    key: "filterTreeNode",
    value: function filterTreeNode(treeNode) {
      var filterTreeNode = this.props.filterTreeNode;

      if (typeof filterTreeNode !== 'function' || treeNode.props.disabled) {
        return false;
      }

      return filterTreeNode.call(this, treeNode);
    }
    /**
     * 将截取后的 List 数组转换为 Tree 结构，并更新 state
     */

  }, {
    key: "renderTreeNode",
    value: function renderTreeNode(child, index) {
      var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      // fix: 懒加载场景，index 计算错误
      var actualIndex = index + parseInt(this.startIndex);
      var pos = "".concat(level, "-").concat(actualIndex);
      if (!child) return null;
      var key = child.key || pos;
      var state = this.state;
      var props = this.props;
      var _this$state$selectedK2 = this.state.selectedKeys,
          selectedKeys = _this$state$selectedK2 === void 0 ? [] : _this$state$selectedK2;
      var tabIndexKey = selectedKeys[0];

      if (tabIndexKey && key == tabIndexKey) {
        this.selectKeyDomExist = true;
        this.selectKeyDomPos = pos;
      } // prefer to child's own selectable property if passed


      var selectable = props.selectable;

      if (child.props.hasOwnProperty('selectable')) {
        selectable = child.props.selectable;
      }

      var draggable = props.draggable;

      if (child.props.hasOwnProperty('draggable')) {
        draggable = child.props.draggable;
      }

      var isLeaf = null;

      if (child.props.hasOwnProperty('isLeaf')) {
        isLeaf = child.props.isLeaf;
      }

      var autoExpand = false; // 自动点击展开

      if (this.autoExpandKeys && this.autoExpandKeys.includes(key)) {
        autoExpand = true;

        var _index = this.autoExpandKeys.indexOf(key);

        this.autoExpandKeys.splice(_index, 0);

        if (this.autoExpandKeys.length === 0) {
          this.autoExpandKeys = null;
        }
      }

      var cloneProps = {
        root: this,
        eventKey: key,
        autoExpand: autoExpand,
        pos: pos,
        selectable: selectable,
        loadData: props.loadData,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onRightClick: props.onRightClick,
        onDoubleClick: props.onDoubleClick,
        onKeyDown: props.onKeyDown,
        clsPrefix: props.clsPrefix,
        showLine: props.showLine,
        showIcon: props.showIcon,
        draggable: draggable,
        dragOver: state.dragOverNodeKey === key && this.dropPosition === 0,
        dragOverGapTop: state.dragOverNodeKey === key && this.dropPosition === -1,
        dragOverGapBottom: state.dragOverNodeKey === key && this.dropPosition === 1,
        _dropTrigger: this._dropTrigger,
        expanded: state.expandedKeys.indexOf(key) !== -1,
        selected: state.selectedKeys.indexOf(key) !== -1,
        focused: state.focusKey === key,
        openTransitionName: this.getOpenTransitionName(),
        openAnimation: props.openAnimation,
        filterTreeNode: this.filterTreeNode.bind(this),
        openIcon: props.openIcon,
        closeIcon: props.closeIcon,
        focusable: props.focusable,
        tabIndexKey: state.selectedKeys[0],
        tabIndexValue: props.tabIndexValue,
        ext: child.props.ext,
        mustExpandable: props.mustExpandable,
        isLeaf: isLeaf
      };

      if (props.checkable) {
        cloneProps.checkable = props.checkable;

        if (props.checkStrictly) {
          if (state.checkedKeys) {
            cloneProps.checked = state.checkedKeys.indexOf(key) !== -1 || false;
          }

          if (props.checkedKeys && props.checkedKeys.halfChecked) {
            cloneProps.halfChecked = props.checkedKeys.halfChecked.indexOf(key) !== -1 || false;
          } else {
            cloneProps.halfChecked = false;
          }
        } else {
          if (this.checkedKeys) {
            cloneProps.checked = this.checkedKeys.indexOf(key) !== -1 || false;
          }

          cloneProps.halfChecked = this.halfCheckedKeys.indexOf(key) !== -1;
        }
      }

      if (this.treeNodesStates && this.treeNodesStates[pos]) {
        Object.assign(cloneProps, this.treeNodesStates[pos].siblingPosition);
      }

      return /*#__PURE__*/React.cloneElement(child, cloneProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      var props = this.props;

      var _this$props9 = this.props,
          showLine = _this$props9.showLine,
          clsPrefix = _this$props9.clsPrefix,
          className = _this$props9.className,
          focusable = _this$props9.focusable,
          checkable = _this$props9.checkable,
          loadData = _this$props9.loadData,
          checkStrictly = _this$props9.checkStrictly,
          tabIndexValue = _this$props9.tabIndexValue,
          lazyLoad = _this$props9.lazyLoad,
          getScrollContainer = _this$props9.getScrollContainer,
          defaultExpandedKeys = _this$props9.defaultExpandedKeys,
          defaultSelectedKeys = _this$props9.defaultSelectedKeys,
          defaultCheckedKeys = _this$props9.defaultCheckedKeys,
          openAnimation = _this$props9.openAnimation,
          draggable = _this$props9.draggable,
          debounceDuration = _this$props9.debounceDuration,
          others = _objectWithoutProperties(_this$props9, _excluded3);

      var customProps = _objectSpread({}, omit(others, ['showIcon', 'cancelUnSelect', 'onCheck', 'selectable', 'autoExpandParent', 'defaultExpandAll', 'onExpand', 'autoSelectWhenFocus', 'expandWhenDoubleClick', 'expandedKeys', 'keyFun', 'openIcon', 'closeIcon', 'treeData', 'checkedKeys', 'selectedKeys', 'renderTreeNodes', 'mustExpandable', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onDoubleClick', "debounceDuration"]));

      var _this$state = this.state,
          treeData = _this$state.treeData,
          flatTreeData = _this$state.flatTreeData;
      var startIndex = this.startIndex,
          endIndex = this.endIndex,
          preHeight = 0,
          sufHeight = 0,
          treeNode = [],
          treeChildren = props.children; //最终渲染在 Tree 标签中的子节点

      if (lazyLoad) {
        preHeight = this.getSumHeight(0, startIndex);
        sufHeight = this.getSumHeight(endIndex, flatTreeData.length);
      }

      if (!props.children && treeData) {
        //传入json数据
        treeNode = this.renderTreefromData(treeData);
        this.cacheTreeNodes = treeNode;
        treeChildren = treeNode;
      }

      var showLineCls = "";

      if (showLine) {
        showLineCls = "".concat(clsPrefix, "-show-line");
      }

      var domProps = {
        className: classNames(className, clsPrefix, showLineCls),
        role: 'tree-node'
      };

      if (focusable) {
        domProps.onFocus = this.onUlFocus;
        domProps.onMouseEnter = this.onUlMouseEnter;
        domProps.onMouseLeave = this.onUlMouseLeave;
      } // if (props.focusable) {
      //   // domProps.tabIndex = '0';//需求改成了默认选择第一个节点或者选中的节点
      //   // domProps.onKeyDown = this.onKeyDown;//添加到具体的treeNode上了
      // }


      var getTreeNodesStates = function getTreeNodesStates() {
        _this7.treeNodesStates = {};
        loopAllChildren(treeChildren, function (item, index, pos, keyOrPos, siblingPosition) {
          _this7.treeNodesStates[pos] = {
            siblingPosition: siblingPosition
          };
        }, undefined, startIndex);
      };

      if (showLine && !checkable) {
        getTreeNodesStates();
      }

      if (checkable && (this.checkedKeysChange || loadData || this.dataChange)) {
        if (checkStrictly) {
          getTreeNodesStates();
        } else if (props._treeNodesStates) {
          this.treeNodesStates = props._treeNodesStates.treeNodesStates;
          this.halfCheckedKeys = props._treeNodesStates.halfCheckedKeys;
          this.checkedKeys = props._treeNodesStates.checkedKeys;
        } else {
          var checkedKeys = this.state.checkedKeys;
          var checkKeys;

          if (!loadData && this.checkKeys && this._checkedKeys && arraysEqual(this._checkedKeys, checkedKeys) && !this.dataChange) {
            // if checkedKeys the same as _checkedKeys from onCheck, use _checkedKeys.
            checkKeys = this.checkKeys;
            this.treeNodesStates = {};
            loopAllChildren(treeChildren, function (item, index, pos, keyOrPos, siblingPosition) {
              _this7.treeNodesStates[pos] = {
                node: item,
                key: keyOrPos,
                checked: false,
                halfChecked: false,
                siblingPosition: siblingPosition
              };

              if (checkedKeys.indexOf(keyOrPos) !== -1) {
                _this7.treeNodesStates[pos].checked = true;
              }
            }, undefined, startIndex);
          } else {
            var checkedPositions = [];
            this.treeNodesStates = {};
            loopAllChildren(treeChildren, function (item, index, pos, keyOrPos, siblingPosition) {
              _this7.treeNodesStates[pos] = {
                node: item,
                key: keyOrPos,
                checked: false,
                halfChecked: false,
                siblingPosition: siblingPosition
              };

              if (checkedKeys.indexOf(keyOrPos) !== -1) {
                _this7.treeNodesStates[pos].checked = true;
                checkedPositions.push(pos);
              }
            }, undefined, startIndex); // if the parent node's key exists, it all children node will be checked

            handleCheckState(this.treeNodesStates, filterParentPosition(checkedPositions), true);
            checkKeys = getCheck(this.treeNodesStates);
          }

          this.halfCheckedKeys = checkKeys.halfCheckedKeys;
          this.checkedKeys = checkKeys.checkedKeys;
        }
      }

      this.selectKeyDomExist = false;
      var isFold = this.cachedLatestState === true;
      return lazyLoad ? /*#__PURE__*/React.createElement(InfiniteScroll, {
        className: "".concat(clsPrefix, "-infinite-scroll"),
        treeList: flatTreeData,
        debounceDuration: debounceDuration || 150,
        isFold: isFold,
        handleTreeListChange: this.handleTreeListChange,
        getScrollParent: getScrollContainer,
        store: this.store
      }, /*#__PURE__*/React.createElement("ul", _extends({}, domProps, {
        unselectable: "true",
        ref: function ref(el) {
          _this7.tree = el;
        },
        tabIndex: focusable && tabIndexValue
      }, customProps), /*#__PURE__*/React.createElement("li", {
        style: {
          height: preHeight
        },
        className: "".concat(clsPrefix, "node-start"),
        key: 'tree_node_start'
      }), React.Children.map(treeChildren, this.renderTreeNode, this), /*#__PURE__*/React.createElement("li", {
        style: {
          height: sufHeight
        },
        className: "".concat(clsPrefix, "node-end"),
        key: 'tree_node_end'
      }))) : /*#__PURE__*/React.createElement("ul", _extends({}, domProps, {
        unselectable: "true",
        ref: function ref(el) {
          _this7.tree = el;
        },
        tabIndex: focusable && tabIndexValue
      }, customProps), React.Children.map(treeChildren, this.renderTreeNode, this));
    }
  }]);

  return Tree;
}(React.Component);

Tree.propTypes = {
  clsPrefix: PropTypes.string,
  children: PropTypes.any,
  showLine: PropTypes.bool,
  showIcon: PropTypes.bool,
  selectable: PropTypes.bool,
  multiple: PropTypes.bool,
  checkable: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
  _treeNodesStates: PropTypes.object,
  checkStrictly: PropTypes.bool,
  draggable: PropTypes.bool,
  autoExpandParent: PropTypes.bool,
  defaultExpandAll: PropTypes.bool,
  defaultExpandedKeys: PropTypes.arrayOf(PropTypes.string),
  expandedKeys: PropTypes.arrayOf(PropTypes.string),
  defaultCheckedKeys: PropTypes.arrayOf(PropTypes.string),
  checkedKeys: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.object]),
  defaultSelectedKeys: PropTypes.arrayOf(PropTypes.string),
  selectedKeys: PropTypes.arrayOf(PropTypes.string),
  onExpand: PropTypes.func,
  onCheck: PropTypes.func,
  onSelect: PropTypes.func,
  loadData: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onRightClick: PropTypes.func,
  onDragStart: PropTypes.func,
  onDragEnter: PropTypes.func,
  onDragOver: PropTypes.func,
  onDragLeave: PropTypes.func,
  onDrop: PropTypes.func,
  onDragEnd: PropTypes.func,
  filterTreeNode: PropTypes.func,
  openTransitionName: PropTypes.string,
  focusable: PropTypes.bool,
  openAnimation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  lazyLoad: PropTypes.bool,
  treeData: PropTypes.array,
  renderTreeNodes: PropTypes.func,
  autoSelectWhenFocus: PropTypes.bool,
  getScrollContainer: PropTypes.func,
  expandWhenDoubleClick: PropTypes.bool
};
Tree.defaultProps = {
  clsPrefix: 'rc-tree',
  showLine: false,
  showIcon: true,
  selectable: true,
  multiple: false,
  checkable: false,
  checkStrictly: false,
  draggable: false,
  autoExpandParent: true,
  defaultExpandAll: false,
  defaultExpandedKeys: [],
  defaultCheckedKeys: [],
  defaultSelectedKeys: [],
  onExpand: noop,
  onCheck: noop,
  onSelect: noop,
  onDragStart: noop,
  onDragEnter: noop,
  onDragOver: noop,
  onDragLeave: noop,
  onDrop: noop,
  onDragEnd: noop,
  tabIndexValue: 0,
  lazyLoad: false,
  autoSelectWhenFocus: false,
  getScrollContainer: noop,
  expandWhenDoubleClick: false
};
export default Tree;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-tree/src/Tree.js